import type { Order } from 'types/delivery.types';
import { formatVehicleType } from 'features/drivers/lib/driverLicenceStatus';
import { formatDriverDisplayName } from 'features/tracking/lib/vehicleMarker';

interface AssignedDriverCardProps {
  order: Order;
}

export default function AssignedDriverCard({ order }: AssignedDriverCardProps) {
  const name = formatDriverDisplayName(order.driver);
  const vehicle = order.vehicle;
  const plate = vehicle?.plateNumber?.trim();
  const typeLabel = vehicle?.type ? formatVehicleType(vehicle.type) : null;

  if (!name && !plate && !typeLabel && !order.driverId) return null;

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 mb-6">
      <p className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-3">
        Your driver
      </p>
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
          <span
            className="material-symbols-outlined text-primary text-2xl"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            person
          </span>
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          {name ? (
            <p className="text-base font-bold text-slate-900">{name}</p>
          ) : (
            <p className="text-base font-bold text-slate-900">Driver assigned</p>
          )}
          <div className="flex flex-wrap gap-2 text-sm text-slate-600">
            {typeLabel && (
              <span className="inline-flex items-center gap-1 bg-slate-50 px-2.5 py-1 rounded-lg">
                <span className="material-symbols-outlined text-[16px] text-slate-500">
                  local_shipping
                </span>
                {typeLabel}
              </span>
            )}
            {plate && (
              <span className="inline-flex items-center gap-1 bg-slate-50 px-2.5 py-1 rounded-lg font-mono text-xs font-semibold tracking-wide">
                {plate}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
